import Api from '@/api/index'

const state = {
  all: [],
  groups: [],
  meta: {
    totalGroups: 0,
    totalInvoices: 0,
    page: 1,
    limit: 'all',
  },
  products: [],
  emptyItems: [],
}

const getters = {
  products: state => {
    return state.products
  },
  emptyItems: state => {
    return state.emptyItems
  },
}

const actions = {
  async getAll({ commit }, params) {
    const invoices = await Api.Invoice.getAll(params)
    if (invoices !== null) {
      commit('setInvoices', invoices)
      return invoices
    }
    return []
  },

  async updateAccounting(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.updateAccounting(params)
  },

  // Trámites que ya tienen ese N° de factura Alegra. Lista vacía si no hay
  // ninguno o si la consulta falla: es solo un aviso, nunca bloquea.
  async checkAlegraNumber(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const response = await Api.Invoice.checkAlegraNumber(params)
    return (response && response.duplicates) || []
  },

  // ===== Facturación por servicios =====
  async getServiceConcepts({
    commit, // eslint-disable-line no-unused-vars
  }) {
    const response = await Api.Invoice.getServiceConcepts()
    return (response && response.concepts) || []
  },

  async saveServiceConcept(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.saveServiceConcept(params)
  },

  async getServiceRates({
    commit, // eslint-disable-line no-unused-vars
  }) {
    const response = await Api.Invoice.getServiceRates()
    return (response && response.rates) || []
  },

  async saveServiceRate(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.saveServiceRate(params)
  },

  async deleteServiceRate(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.deleteServiceRate(params)
  },

  async getServiceItems(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const response = await Api.Invoice.getServiceItems(params)
    return (response && response.rows) || []
  },

  async generateServiceItems(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.generateServiceItems(params)
  },

  async saveServiceItem(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.saveServiceItem(params)
  },

  async deleteServiceItem(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.deleteServiceItem(params)
  },

  async uploadServiceDocs(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.uploadServiceDocs(params)
  },

  // ===== Reembolsos =====
  async getReimbursementConcepts({
    commit, // eslint-disable-line no-unused-vars
  }) {
    const response = await Api.Invoice.getReimbursementConcepts()
    return (response && response.concepts) || []
  },

  async saveReimbursementConcept(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.saveReimbursementConcept(params)
  },

  async getReimbursements(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const response = await Api.Invoice.getReimbursements(params)
    return (response && response.lines) || []
  },

  async saveReimbursement(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.saveReimbursement(params)
  },

  async deleteReimbursement(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.deleteReimbursement(params)
  },

  async uploadReimbursementDocs(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.uploadReimbursementDocs(params)
  },

  async getCustomsRates({
    commit, // eslint-disable-line no-unused-vars
  }) {
    const response = await Api.Invoice.getCustomsRates()
    return (response && response.rates) || []
  },

  async saveCustomsRate(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.saveCustomsRate(params)
  },

  async deleteCustomsRate(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.deleteCustomsRate(params)
  },

  async recalculateCustoms(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.recalculateCustoms(params)
  },

  async deleteDocument(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.deleteDocument(params)
  },

  // Bitácora de documentos: no se guarda en el store, la consume el diálogo
  // que la pide y se refresca en cada apertura.
  async getDocuments(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const response = await Api.Invoice.getDocuments(params)
    return (response && response.documents) || []
  },

  async getConsolidated({ commit }, params) {
    const response = await Api.Invoice.getConsolidated(params)
    const data =
      response && Array.isArray(response.groups)
        ? response
        : {
            groups: [],
            totalGroups: 0,
            totalInvoices: 0,
            page: 1,
            limit: 'all',
          }
    commit('setConsolidated', data)
    return data
  },

  async consolidate(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.consolidate(params)
  },

  async addToConsolidated(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.addToConsolidated(params)
  },

  async removeFromConsolidated(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.removeFromConsolidated(params)
  },

  // Busca cuadrantes sin afectar el estado del listado (para el selector).
  async searchGroups(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const response = await Api.Invoice.getConsolidated(params)
    return (response && response.groups) || []
  },

  async deconsolidate(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.deconsolidate(params)
  },

  // Motivos de pendiente (catálogo + asignación por factura).
  async getPendingReasons({
    commit, // eslint-disable-line no-unused-vars
  }) {
    return Api.PendingReason.getActive()
  },

  async createPendingReason(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    name
  ) {
    return Api.PendingReason.create(name)
  },

  async setInvoicePendingReasons(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    return Api.Invoice.setPendingReasons(params)
  },

  async getById(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const Product = await Api.Invoice.getById(params)
    if (Product !== null) {
      return Product
    }
    return null
  },

  async save(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    Product
  ) {
    const result = await Api.Invoice.save(Product)
    return result
  },

  async delete(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.Invoice.delete(params)
    return result
  },

  async caseReady(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.Invoice.caseReady(params)
    return result
  },

  async getItems(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    let items = await Api.Invoice.getProducts(params)
    return items
  },

  async updateProcessFields(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    { id, ...params }
  ) {
    const result = await Api.Invoice.updateProcessFields(id, params)
    return result
  },

  resetEmptyItems({ commit }) {
    commit('setEmptyItems', [])
  },
}

const mutations = {
  setInvoices(state, invoices) {
    state.all = invoices.items
  },

  setConsolidated(state, data) {
    state.groups = data.groups
    state.meta = {
      totalGroups: data.totalGroups || 0,
      totalInvoices: data.totalInvoices || 0,
      page: data.page || 1,
      limit: data.limit,
    }
  },

  setProducts(state, products) {
    state.products = products
  },

  setEmptyItems(state, emptyItems) {
    state.emptyItems = emptyItems
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
